import React, { PureComponent } from 'react';
import { IChartSeries } from 'types';
// Components
import Chart from 'components/chart';
interface SessionChartProps {
  session: IChartSeries[];
  chartKeys: string[];
  onPointHover: (e: Object) => void;
  onPointClick: (e: Object) => void;
}

export default class SessionChart extends PureComponent<SessionChartProps> {
  render() {
    const { series, onPointHover, onPointClick, onRange } = this.props;
    return (
      <>
        <Chart
          series={series}
          onPointHover={onPointHover}
          onPointClick={onPointClick}
          onRange={onRange}
        />
      </>
    );
  }
}
